module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/topimgs-383111c32fd65f690e7079cf73b9e747.png";